// extracted by mini-css-extract-plugin
export default {"detailCard":"IhgBriefDetailView_detailCard__YeVwa"};